import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, map, of, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

export interface StatusCount {
  status: string;
  count: number;
}

export interface User {
  id: number;
  createdAt: string;
  updatedAt: string;
  name?: string | null;
  mobileNumber: string | null;
  email: string;
  alternateEmail: string | null;
  dateOfBirth?: string | null;
  profilePic?: string | null;
  motherTongue?: string | null;
  dob?: string | null;
  isEmailVerified: boolean;
  isDetailSubmitted: boolean;
  hasSubscription: boolean;
  isSubmittedByDopt: boolean;
  isActive: boolean;
  retirementReason?: string | null;
  gender?: string | null;
  lastLoggedInAt: string;
  profilePicture?: string | null;
  batchYear?: number | null;
  role: string;
  status: string;
  doptOfficer: any | null;
  cadre?: any | null;
  statusCount?: StatusCount[];
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private apiUrl = `${environment.apiUrl}/accounts/whoami`;
  private userSubject = new BehaviorSubject<User | null>(null);
  user$ = this.userSubject.asObservable();

  constructor(private http: HttpClient, private router: Router) {
    this.autoFetchUser();
  }

  getUser(): Observable<User | null> {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return of(null);
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });

    return this.http.get<{ data: any }>(this.apiUrl, { headers }).pipe(
      map(response => {
        let parsed: User;

        if (typeof response.data === 'string') {
          parsed = JSON.parse(response.data);
        } else {
          parsed = response.data;
        }

        this.userSubject.next(parsed);
        return parsed;
      }),
      catchError(err => {
        // 🚨 If API fails → auto logout
        this.logout('Your session has expired. Please login again.');
        return throwError(() => err);
      })
    );
  }

  refreshUser(): Observable<User | null> {
    return this.getUser();
  }

  getCurrentUser(): User | null {
    return this.userSubject.value;
  }

  private autoFetchUser() {
    const token = localStorage.getItem('authToken');
    if (token) {
      this.getUser().subscribe({
        error: () => {
          // handled in catchError
        }
      });
    }
  }

  logout(message?: string) {
    this.userSubject.next(null);
     localStorage.clear();       // 🔑 remove everything
    sessionStorage.clear();     // optional, in case you store something there
    this.userSubject.next(null);

    // Optionally show toast/alert
    if (message) {
      alert(message); // 👉 Replace with Angular Material snackbar / Toastr for better UX
    }

    // Redirect to login
    this.router.navigate(['']);
  }
}
